module.exports = __webpack_public_path__ + "img/icon-update.3312a0b0.svg";